import React, { useEffect, useState } from 'react'
import { KTIcon } from '../../../../_metronic/helpers'
import { getCloudStatus, getCloudsStatus, getCloudStatusGlobal, getCloudsStatusG } from './request/request'
import { useAppSelector } from '../../../../redux/hooks'
import { useAuth } from '../../auth'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import styles from './cloudStatusTable.module.scss'; // Importa el mismo estilo que en licenseCrud

type Props = {
  className: string
}

const TablesWidget5: React.FC<Props> = ({ className }) => {
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Cloud = useAppSelector(state => state.CloudSlice.Type)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const { currentUser } = useAuth()

  const [statuCloud, setstatusCloud] = useState<{ cloud: string; region: string; status: string }[]>([])

  // Estados para búsqueda, paginación, filtrado por columna y ordenación
  const [searchTerm, setSearchTerm] = useState("")
  const [searchColumn, setSearchColumn] = useState("All")
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(5)

  // Estados para ordenación
  const [sortColumn, setSortColumn] = useState<string>("")
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc'
        ? <KeyboardArrowUpIcon className={styles['sort-icon']} />
        : <KeyboardArrowDownIcon className={styles['sort-icon']} />;
    } else {
      return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />;
    }
  }

  function applySearch(data: any[]) {
    if (!searchTerm) return data
    const lowerTerm = searchTerm.toLowerCase()
    return data.filter(d => {
      if (searchColumn === 'All') {
        return (
          d.cloud?.toLowerCase().includes(lowerTerm) ||
          d.region?.toLowerCase().includes(lowerTerm) ||
          d.status?.toLowerCase().includes(lowerTerm)
        )
      } else {
        return d[searchColumn]?.toString().toLowerCase().includes(lowerTerm)
      }
    })
  }

  function applySort(data: any[]) {
    if (!sortColumn) return data
    const sorted = [...data].sort((a, b) => {
      const valA = a[sortColumn]?.toString().toLowerCase() || ''
      const valB = b[sortColumn]?.toString().toLowerCase() || ''
      if (valA < valB) return sortDirection === 'asc' ? -1 : 1
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1
      return 0
    })
    return sorted
  }

  const filteredData = applySearch(statuCloud)
  const sortedData = applySort(filteredData)

  // Paginación
  const totalItems = sortedData.length
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage
  const paginatedData = sortedData.slice(startIndex, endIndex)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value)
    setCurrentPage(1)
  }

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  useEffect(() => {
    if (Id && Id !== 0 && Id !== -1 && tenant === 0 && Cloud !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
      getCloudStatus(Id, Cloud, nameregion).then(response => {
        setstatusCloud(response.data)
      })
    } else if (Id && Id !== 0 && Id !== -1 && tenant !== 0 && Cloud !== 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
      getCloudStatusGlobal(Id, tenant, Cloud, nameregion).then(response => {
        setstatusCloud(response.data)
      })
    } else if (Id === -1 && tenant === 0 && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
      getCloudsStatus(-1).then(response => {
        setstatusCloud(response.data)
      })
    } else if (Id === -1 && tenant !== 0 && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
      getCloudsStatusG(-1, tenant).then(response => {
        setstatusCloud(response.data)
      })
    } else if (Id && Cloud !== '' || Cloud !== null) {
      if (Id !== 0 && Id !== -1 && tenant === 0 && Cloud === 'CloudGlobal' && nameregion === '' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getCloudStatus(Id).then(response => {
          setstatusCloud(response.data)
        })
      } else if (Id !== 0 && Id !== -1 && tenant !== 0 && Cloud === 'CloudGlobal' && nameregion === '' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getCloudStatusGlobal(Id, tenant).then(response => {
          setstatusCloud(response.data)
        })
      }
    }
  }, [Id, nameregion, tenant, Cloud, currentUser])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1 f-titulo text-marino'>Cloud Status</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>
          <div className='table-responsive'>

            {statuCloud.length > 0 && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', marginRight: '5px' }}>
                <div>
                  <span className="text-marino f-parrafo fw-semibold">
                    Total Records: {totalItems}
                  </span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                  <div className="input-group custom-search-group" style={{ display: 'flex', height: '30px' }}>
                    <span
                      className="input-group-text"
                      style={{
                        justifyContent: 'center',
                        height: '30px',
                        lineHeight: '30px',
                        padding: '0 8px'
                      }}
                    >
                      <i
                        className="bi-search"
                        style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                      ></i>
                    </span>
                    <select
                      className="form-select"
                      style={{
                        border: '1px solid var(--bs-gray-300)',
                        width: '100px',
                        height: '30px',
                        lineHeight: '30px',
                        padding: '0 8px',
                        fontSize: '0.875rem'
                      }}
                      value={searchColumn}
                      onChange={(e) => { setSearchColumn(e.target.value); setCurrentPage(1); }}
                    >
                      <option value="All">All</option>
                      <option value="cloud">Cloud</option>
                      <option value="region">Region</option>
                      <option value="status">Status</option>
                    </select>
                    <input
                      type="text"
                      className="form-control"
                      style={{
                        width: '150px',
                        height: '30px',
                        lineHeight: '30px',
                        padding: '0 8px',
                        fontSize: '0.875rem'
                      }}
                      placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                  </div>
                </div>
              </div>
            )}

            {statuCloud.length === 0 ? (
              <div className="no-data-message">No Data Available</div>
            ) : (
              <>
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead>
                    <tr className='text-azul text-left'>
                      <th className='table-cell' onClick={() => handleSort('cloud')} style={{ cursor: 'pointer' }}>
                        <div className={styles['header-content']}>
                          <span>Cloud</span>
                          <span className={styles['sortable-column']}>{getSortIcon('cloud')}</span>
                        </div>

                      </th>
                      <th className="table-cell" onClick={() => handleSort('region')} style={{ cursor: 'pointer' }}>
                        <div className={styles['header-content']}>
                          <span>Region</span> <span className={styles['sortable-column']}>{getSortIcon('region')}</span>
                        </div>

                      </th>
                      <th className="table-cell" onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                        <div className={styles['header-content']}>
                          <span>Status</span>
                          <span className={styles['sortable-column']}>{getSortIcon('status')}</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((d, m) => (
                      <tr key={m} className="table-row">
                        <td className="table-cell"><span className='badge badge-secondary'>{d.cloud}</span></td>
                        <td className="table-cell">{d.region}</td>
                        <td className={`table-cell ${styles['mid-row']}`}>
                          <span className='symbol-label'>
                            {((Cloud === 'AWS' || Cloud === 'OCI') && Id !== 0) || Cloud === 'CloudGlobal' ? (
                              <>
                                {(d.status === "UP" || d.status === "healthy") && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                                {(d.status === "Degradation" || d.status === "degraded") && <KTIcon iconName='bi bi-exclamation-triangle' className='text-warning fs-1' />}
                                {(d.status === "Informational" || d.status === "Detected" || d.status === "advisory") && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                                {d.status === "unhealthy" && <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' />}
                                {d.status === "unknown" && <KTIcon iconName='bi bi-circle' className='text-gray-300 fs-1' />}
                              </>
                            ) : Cloud === 'AZR' && Id !== 0 ? (
                              <>
                                {d.status === "healthy" && <KTIcon iconName='bi bi-check-circle' className='text-success fs-1' />}
                                {d.status === "degraded" && <KTIcon iconName='bi bi-exclamation-circle' className='text-warning fs-1' />}
                                {d.status === "unhealthy" && <KTIcon iconName='bi bi-x-circle' className='text-danger fs-1' />}
                                {d.status === "advisory" && <KTIcon iconName='bi bi-info-circle' className='text-primary fs-1' />}
                                {d.status === "unknown" && <KTIcon iconName='bi bi-circle' className='text-gray-300 fs-1' />}
                              </>
                            ) : null}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {filteredData.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                    <div>
                      {currentPage > 1 && (
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Previous
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span>Page {currentPage} of {totalPages}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      {currentPage < totalPages && (
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Next
                        </button>
                      )}

                      <div className={`select-container ${styles.selectContainer}`}>
                        <select
                          className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                          aria-label="Select items per page"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value))
                            setCurrentPage(1)
                          }}
                        >
                          <option value={5}>5 rows</option>
                          <option value={10}>10 rows</option>
                          <option value={20}>20 rows</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}

            {Id === 0 && Cloud !== 'Global' && (
              <table className="table table-striped gy-7 gs-7">
                <tbody>
                  <div className="text-center">Select a Cloud with available subscriptions</div>
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export { TablesWidget5 }
